import { useContext } from 'react';
import { ConfigContext } from '@/providers/ConfigProvider/ConfigProvider';

/**
 * Custom hook to access the use-case specific configuration
 * @returns The config context value.
 */
export function useConfig() {
  const context = useContext(ConfigContext);

  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
}
